var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};

export default SortDirection;


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/es/Table/SortDirection.js
// module id = 588
// module chunks = 0